import styled, { css } from 'styled-components';
import Title from 'desktop/components/Title';
import Icon from 'desktop/components/Icon';
import { colorVariables, mediaTemplates } from 'desktop/theme/variables';
import { ReactComponent as LockSprite } from 'assets/icons/lock.svg';

export const ProgramStyled = styled.div`
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 165px;
  margin-left: 160px;
  display: flex;
  align-items: flex-start;
  width: auto !important;

  ${mediaTemplates.s} {
    margin-left: 20px;
    padding-bottom: 5px;
    margin-top: 0;
  }

  ${mediaTemplates.l} {
    margin-left: 210px;
  }

  &:last-child {
    margin-bottom: 0;

    ${mediaTemplates.l} {
      margin-bottom: 35px;
    }
  }

  ${(props) =>
    props.available &&
    css`
      cursor: pointer;
    `};
`;

export const LeftPart = styled.div`
  position: relative;
  margin-right: 20px;
  width: 41px;
  display: flex;
  align-items: center;
`;

export const RightPart = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const Current = styled.span`
  position: absolute;
  left: -17px;
  top: calc(50% - 3px);
  display: block;
  width: 6px;
  height: 6px;
  background-color: ${colorVariables.red};
  border-radius: 50%;
`;

export const Time = styled.div`
  position: relative;
`;

export const TitleWrap = styled.div`
  position: relative;
`;

export const LastWordWrap = styled.div`
  display: inline-block;
  white-space: nowrap;
`;

export const RecordWrap = styled.span`
  top: 2px;
  position: relative;
  font-size: 0;
  opacity: 0;
  visibility: hidden;
  margin-left: 6px;
  transition: all 0.1s;

  ${(props) =>
    props.available &&
    css`
      opacity: 1;
      visibility: visible;
    `};
`;

export const StyledTime = styled(Title)`
  && {
    color: ${colorVariables.gray_darksmoke};
    ${(props) =>
      (props.playing || props.currentLineal) &&
      css`
        color: ${colorVariables.orange};
      `};
    ${(props) =>
      props.available &&
      css`
        ${ProgramStyled}:hover & {
          color: ${colorVariables.fire};
          transition: 135ms ease-out;
        }
      `};
  }
`;

export const StyledTitle = styled(Title)`
  && {
    color: white;
    ${(props) =>
      props.ended &&
      css`
        color: ${colorVariables.gray_darksmoke};
      `};
    ${(props) =>
      (props.playing || props.currentLineal) &&
      css`
        color: ${colorVariables.orange};
      `};
    ${(props) =>
      props.available &&
      css`
        ${ProgramStyled}:hover & {
          color: ${colorVariables.fire};
          transition: 135ms ease-out;
        }
      `};
  }
`;

export const StyledIcon = styled(Icon)`
  && {
    color: ${colorVariables.gray_darksmoke};
    ${(props) =>
      props.available &&
      css`
        ${ProgramStyled}:hover & {
          color: ${colorVariables.fire};
          transition: 135ms ease-out;
        }
      `};
  }
`;

export const ProgramLockIcon = styled(LockSprite)`
  && {
    position: absolute;
    left: -22px
    top: 50%;
    transform: translate(0, -50%);
    width: 16px;
    height: 16px;
    fill: rgba(255, 255, 255, 0.4)
  }
`;
